module.exports = __webpack_public_path__ + "static/key-end-users-1f9f69eb058e4b05ef91dd96b8b7ce66.svg";